package com.patronat.top.features.auth.data.repository

import com.patronat.top.core.auth.TokenStorage
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.domain.usecase.command.auth.*
import com.patronat.top.core.network.NetworkResult
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.dto.AuthResponse
import com.patronat.top.dto.AuthSuccessResponse
import com.patronat.top.features.auth.data.mappers.toDomain
import com.patronat.top.features.auth.data.network.AuthRemoteDataSource
import com.patronat.top.features.auth.domain.models.AuthResult
import com.patronat.top.features.auth.domain.repository.AuthRepository

class AuthRepositoryImpl(
    val remoteDataSource: AuthRemoteDataSource,
    val tokenStorage: TokenStorage
) : AuthRepository {

    override suspend fun startRegistration(command: RegistrationUserCommand): DomainResult<AuthResult> {
        val result = remoteDataSource.startRegistration(command)
        saveTokensIfPresent(result)
        return result.asDomainResult { it.toDomain() }
    }

    override suspend fun startLogin(command: LoginCommand): DomainResult<AuthResult> {
        val result = remoteDataSource.startLogin(command)
        saveTokensIfPresent(result)
        return result.asDomainResult { it.toDomain() }
    }

    override suspend fun confirmPhone(command: ConfirmPhoneCommand): DomainResult<AuthResult> {
        val result = remoteDataSource.confirmPhone(command)
        saveTokensIfPresent(result)
        return result.asDomainResult { it.toDomain() }
    }

    override suspend fun confirmEmail(command: ConfirmEmailCommand): DomainResult<AuthResult> {
        val result = remoteDataSource.confirmEmail(command)
        saveTokensIfPresent(result)
        return result.asDomainResult { it.toDomain() }
    }

    private suspend fun saveTokensIfPresent(result: NetworkResult<AuthResponse>) {
        if (result is NetworkResult.Success) {
            val response = result.data
            if (response is AuthSuccessResponse) {
                tokenStorage.saveTokens(
                    accessToken = response.accessToken,
                    refreshToken = response.refreshToken,
                    role = response.userRole
                )
            }
        }
    }


    override suspend fun resendPhoneCode(command: SendCodeToPhoneCommand): DomainResult<AuthResult> {
        val result = remoteDataSource.resendPhoneCode(command)
        return result.asDomainResult { it.toDomain() }
    }

    override suspend fun resendEmailCode(command: SendCodeToEmailCommand): DomainResult<AuthResult> {
        val result = remoteDataSource.resendEmailCode(command)
        return result.asDomainResult { it.toDomain() }
    }

    override suspend fun isUserLoggedIn(): Boolean {
        return tokenStorage.getAccessToken() != null
    }

    override suspend fun logout() {
        tokenStorage.clear()
    }

}
